import * as Headless from '@headlessui/react';
import { Link as TanStackLink, type LinkComponentProps } from '@tanstack/react-router';
import { forwardRef } from 'react';

export const Link = forwardRef<HTMLAnchorElement, { href: LinkComponentProps['to'] } & Omit<LinkComponentProps, 'to'>>(
  function Link(props, ref) {
    return (
      <Headless.DataInteractive>
        <TanStackLink {...props} to={props.href} ref={ref} />
      </Headless.DataInteractive>
    );
  }
);
